var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":`${_vm.constants.DIALOG_PORTAL_KEY}.content`}},[_c('event-agreement-info',_vm._b({},'event-agreement-info',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }